// Module
var code = `<div class="row justify-content-center">
	<div class="col-12 col-md-6 col-lg-4">
		<scenes></scenes>
	</div>
</div>
`;
// Exports
export default code;